import { Params, Router } from '@angular/router';

export const getCountryLangUrl = (params: Params): string => {
    const countryCode = params.countryCode;
    const langCode = params.langCode;
    return langCode ? `${countryCode}/${langCode}` : countryCode;
};

export const handleNavigationCanActivateUseCase = (
    urlSuffix: string,
    params: Params,
    router: Router,
) => {
    const countryLangUrl = getCountryLangUrl(params);
    router.navigateByUrl(`${countryLangUrl}${urlSuffix}`, { skipLocationChange: true });
    return false;
};
